<template>
    <admin-app-label class="my-4">Videos</admin-app-label>

    <div v-for="(video, index) of modelValue" class="flex gap-4 mb-4">
        <div class="flex-grow">
            <admin-app-label>Video Title</admin-app-label>
            <input-basic
                placeholder="Video Title"
                v-model="video.title"
                :error="errors[`videos.${index}.title`]"
            />
        </div>
        <div class="flex-grow">
            <admin-app-label>Video Type</admin-app-label>
            <input-select
                placeholder="Video Type"
                labelKey="Video Type"
                label="label"
                v-model="video.type"
                :options="videoTypes"
                :reduce="type => type.value"
                :error="errors[`videos.${index}.type`]"
            />
        </div>
        <div class="flex-grow">
            <admin-app-label>Video ID</admin-app-label>
            <input-basic
                placeholder="Video ID"
                v-model="video.video_id"
                :error="errors[`videos.${index}.video_id`]"
            />
            <p class="text-sm">e.g youtube.com/watch?v=<strong>5eZOOEkrf6Q</strong></p>
        </div>
        <div class="flex-grow self-center">
            <Checkbox v-model:checked="video.featured"></Checkbox>
            Featured
        </div>
        <div class="flex-grow-0 self-center">
            <FontAwesomeIcon @click="removeVideo(index)"
                             class="text-danger cursor-pointer"
                             :icon="['fas', 'circle-xmark']"></FontAwesomeIcon>
        </div>
    </div>

    <label @click="addVideo" class="block tracking-wider uppercase cursor-pointer mt-2">
        <font-awesome-icon icon="plus" class="mr-3"/>
        Add A Video
    </label>
</template>

<script setup>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import InputError from "@/Components/Forms/Inputs/InputError";
import AppButton from "@/Components/AppButton";
import Checkbox from "@/Components/Checkbox";
import {computed} from "vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
    modelValue: {
        type: Array,
        default: [],
    },
    errors: Object
});

const videos = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit("update:modelValue", value);
    }
});

const videoTypes = [
    {label: "YouTube", value: "youtube"},
    {label: "Vimeo", value: "vimeo"}
];

const addVideo = () => {
    emit("update:modelValue", [...videos.value, {
        title: null,
        type: null,
        video_id: null,
        featured: false
    }]);
};

const removeVideo = index => {
    const videosCopy = [...videos.value];

    videosCopy.splice(index, 1);

    emit("update:modelValue", videosCopy);
};

const updateVideo = index => {

};
</script>

<style scoped>

</style>
